module.exports = new __parcel__URL__("the-room.dfdb699b.jpg").toString();